module.exports = __webpack_public_path__ + "static/media/layout-white.00c0a080.svg";